import { useRef, useEffect } from 'react';

// hook to determine if a component is being rendered for the first time
export const useIsMount = () => {
  const isMountRef = useRef(true);
  useEffect(() => {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};